import './src/css/global.css'
import './src/css/typography.css'

export const onClientEntry = () => {}